<template>
  <section class="eligibility-tool__outcome" :class="outcomeClass">
    <h2 :id="headingId" ref="screenHeading" class="eligibility-tool__heading eligibility-tool__heading--outcome" tabindex="-1" data-modal-heading>{{ outcome.title }}</h2>
    <p class="eligibility-tool__lead eligibility-tool__lead--outcome">{{ outcome.primary }}</p>
    <p v-if="outcome.secondary" class="eligibility-tool__body eligibility-tool__body--outcome" v-html="outcome.secondary"></p>

    <div v-if="answerSummary.length" class="eligibility-tool__summary" aria-labelledby="answer-summary-title">
      <h3 id="answer-summary-title" class="eligibility-tool__summary-title">Your answers</h3>
      <dl class="eligibility-tool__answer-list">
        <div v-for="item in answerSummary" :key="item.id || item.question" class="eligibility-tool__answer-item">
          <span class="eligibility-tool__answer-row-icon" :class="`eligibility-tool__answer-row-icon--${rowStatus(item)}`" aria-hidden="true">
            {{ rowIcon(item) }}
          </span>
          <div class="eligibility-tool__answer-content">
            <dt class="eligibility-tool__answer-question">{{ item.question }}</dt>
            <dd class="eligibility-tool__answer-response">
              <span :id="`contextual-offers-summary-${item.id || sanitizeId(item.question)}-answer`" class="eligibility-tool__answer-value">{{ item.answer }}</span>
              <span v-if="item.note" :id="`contextual-offers-summary-${item.id || sanitizeId(item.question)}-note`" class="eligibility-tool__answer-note-box" :class="`eligibility-tool__answer-note-box--${item.noteStatus || 'neutral'}`">
                {{ item.note }}
              </span>
            </dd>
          </div>
        </div>
      </dl>
    </div>

    <div class="eligibility-tool__actions eligibility-tool__actions--outcome button-group">
      <button id="contextual-offers-start-again-button" class="button button--outline bg-black eligibility-tool__button eligibility-tool__button--secondary" type="button" @click="$emit('restart')">Start again</button>
      <p class="eligibility-tool__body eligibility-tool__body--survey"><a id="contextual-offers-survey-link" class="eligibility-tool__survey-link" href="https://forms.office.com/pages/responsepage.aspx?id=MH_ksn3NTkql2rGM8aQVG8RFe8SqJHJLqujAaG4ePjtUN1NOVEw5R0VFVlVRS0FXTThBT0pUV1BBNCQlQCN0PWcu&route=shorturl" target="_blank" rel="noopener noreferrer">Help us improve our service</a></p>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { outcomes, getAnswerSummary } from '../../utils/decisionTree';

export default {
  name: 'OutcomeScreen',
  props: { outcomeId: { type: String, required: true } },
  computed: {
    ...mapState(['answers']),
    outcome() { return outcomes[this.outcomeId]; },
    outcomeClass() { return `eligibility-tool__outcome--${this.outcome.status || (this.outcome.eligible ? 'success' : 'unsuccessful')}`; },
    answerSummary() { return getAnswerSummary(this.answers, this.outcomeId); },
    headingId() { return this.outcomeId === 'O1' ? 'contextual-offers-dialog-title' : `contextual-offers-${this.outcomeId.toLowerCase()}-heading`; }
  },
  mounted() { this.focusHeading(); },
  watch: { outcomeId() { this.focusHeading(); } },
  methods: {
    focusHeading() {
      this.$nextTick(() => {
        const modalContent = this.$el.closest('.eligibility-tool__modal-content');
        if (modalContent) modalContent.scrollTo({ top: 0, left: 0 });
        if (this.$refs.screenHeading) this.$refs.screenHeading.focus({ preventScroll: true });
      });
    },
    sanitizeId(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); },
    rowStatus(item) {
      if (item.noteStatus) return item.noteStatus;
      if (item.answerStatus) return item.answerStatus;
      return this.outcome.eligible ? 'error' : 'error';
    },
    rowIcon(item) {
      const status = this.rowStatus(item);
      if (status === 'success') return '✓';
      if (status === 'unconfirmed' || status === 'unknown') return '?';
      return '×';
    }
  }
};
</script>
